import styled from 'styled-components';

import { ColorScheme } from '~/design-tokens/themes/themes';
import { Variant } from '../../utils';

const colors: Record<Variant, string> = {
  positive: 'var(--viz-bullish)',
  negative: 'var(--viz-bearish)',
  neutral: 'var(--viz-neutral)',
};

export const softColors: Record<Variant, string> = {
  positive: 'var(--viz-bullish-soft)',
  negative: 'var(--viz-bearish-soft)',
  neutral: 'var(--viz-neutral-soft)',
};

export const LineColorBlendMask = styled.rect<{
  $variant: Variant;
  $colorScheme?: ColorScheme;
}>`
  fill: ${({ $variant }) => colors[$variant]};
  mix-blend-mode: ${({ $colorScheme }) =>
    $colorScheme === ColorScheme.Light ? 'lighten' : 'darken'};
`;

export const AreaRectBackground = styled.rect<{
  $variant: Variant;
}>`
  fill: ${({ $variant }) => softColors[$variant]};
  mix-blend-mode: color;
`;

export const EdgeLine = styled.line<{ $variant: Variant }>`
  stroke: ${({ $variant }) => colors[$variant]};
  stroke-width: 1;
  stroke-dasharray: 3 2;
`;

export const LineAxis = styled.line<{ $variant: Variant }>`
  stroke: ${({ $variant }) => colors[$variant]};
  stroke-width: 1;
`;
